export default __webpack_public_path__ + "static/media/fiebre_origen_desconocido.be712391.pdf";